/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Image } from '@builder.io/react';

const SectionMedia = ({
  backgroundMedia,
  backgroundImage,
  backgroundVideo,
  mediaObjectFit,
  mediaObjectPosition,
}) => {
  const sectionMediaStyles = {
    height: '100%',
    left: 0,
    objectFit: mediaObjectFit,
    objectPosition: mediaObjectPosition,
    position: 'absolute',
    top: 0,
    width: '100%',
  };

  if (backgroundMedia === 'image' && backgroundImage) {
    return <Image image={backgroundImage} sx={sectionMediaStyles} />;
  }
  if (backgroundMedia === 'video' && backgroundVideo) {
    return (
      <video autoPlay loop muted playsInline sx={sectionMediaStyles}>
        <source
          type="video/mp4"
          src={backgroundVideo}
          sx={{
            objectFit: mediaObjectFit,
            height: '100%',
            width: '100%',
          }}
        />
      </video>
    );
  }
  return null;
};

export default SectionMedia;
